module.exports = __webpack_public_path__ + "static/media/MDEX.ba78eac1.png";